module.exports = new __parcel__URL__("unmaintained.684100d8.svg").toString();